import request from '@/utils/request'
import type { AxiosResponse } from 'axios'
import type { LaravelResource } from '../types'
import type { Account } from '@/models/Account'

/** PATCH /api/v2/account */
export function updateAccount(
  data: Partial<Account>,
): Promise<AxiosResponse<LaravelResource<Account>>> {
  return request({
    url: '/api/v2/account',
    method: 'patch',
    data,
  })
}

/** POST /api/v2/account/terms */
export function acceptTC(accepted: boolean): Promise<AxiosResponse<void>> {
  return request({
    url: '/api/v2/account/terms',
    method: 'post',
    data: { terms: accepted },
  })
}

/** POST /api/v2/accounts/register — public */
export function register(
  name: string,
  first_name: string,
  last_name: string,
  username: string,
  email: string,
  terms: boolean,
  recaptcha_token: string,
): Promise<AxiosResponse<LaravelResource<Account>>> {
  return request({
    url: '/api/v2/accounts/register',
    method: 'post',
    data: {
      token: recaptcha_token,
      name,
      first_name,
      last_name,
      username,
      email,
      terms,
    },
  })
}

/** GET /api/v2/account */
export function getAccount(): Promise<AxiosResponse<LaravelResource<Account>>> {
  return request({
    url: '/api/v2/account',
    method: 'get',
  })
}

export interface AccountStorage {
  used_bytes: number
  quota_bytes: number
}

/** GET /api/v2/account/storage — live usage (task and protocol files) and the quota (manager). */
export function getAccountStorage(): Promise<AxiosResponse<LaravelResource<AccountStorage>>> {
  return request({
    url: '/api/v2/account/storage',
    method: 'get',
  })
}
